import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalService } from '../core/global.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var PersonService = /** @class */ (function () {
    function PersonService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'eqcpcc': this._global.find(_GlobalNS.paths.eqcpcc)
            })
        };
    }
    PersonService.prototype.findByEmail = function (email) {
        var getApi = _GlobalNS.api.partner.searchByEmail;
        var params = new HttpParams().set('email', email).set('relationshipID', this._global.find(_GlobalNS.paths.RelationshipId));
        this.httpOptions['params'] = params;
        return this._http.get("" + getApi, this.httpOptions);
    };
    PersonService.prototype.findById = function (PersonId) {
        var params = new HttpParams().set('PersonId', PersonId.toString());
        this.httpOptions['params'] = params;
        return this._http.get("" + _GlobalNS.api.person.getById, this.httpOptions);
    };
    PersonService.prototype.findByEmailOption = function (PersonId) {
        var params = new HttpParams().set('PersonId', PersonId.toString());
        this.httpOptions['params'] = params;
        return this._http.get("" + _GlobalNS.api.person.emailOption, this.httpOptions);
    };
    PersonService.prototype.updateEmailOption = function (Data) {
        var api = _GlobalNS.api.person.emailOption;
        var params = new HttpParams().set('eqrf', this._global.find(_GlobalNS.paths.eqrf));
        this.httpOptions['params'] = params;
        return this._http.post("" + api, Data, this.httpOptions);
    };
    PersonService.prototype.update = function (Data) {
        var api = _GlobalNS.api.person.update;
        var params = new HttpParams().set('eqrf', this._global.find(_GlobalNS.paths.eqrf));
        this.httpOptions['params'] = params;
        return this._http.post("" + api, Data, this.httpOptions);
    };
    PersonService.prototype.sendEmail = function (PersonId, resetPassword) {
        var api = _GlobalNS.api.general.sendEmail;
        var params = new HttpParams().set('PersonId', PersonId.toString())
            .set('eqrf', this._global.find(_GlobalNS.paths.eqrf))
            .set('resetPassword', ((resetPassword != null || resetPassword != undefined) ? 'true' : 'false'));
        this.httpOptions['params'] = params;
        return this._http.post("" + api, {}, this.httpOptions);
    };
    PersonService.prototype.getFullName = function (person) {
        return (person.FirstName === (undefined || null) || person.FirstName.length <= 0)
            ? null : person.FirstName + " " + person.LastName;
    };
    PersonService.ngInjectableDef = i0.defineInjectable({ factory: function PersonService_Factory() { return new PersonService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: PersonService, providedIn: "root" });
    return PersonService;
}());
export { PersonService };
